import { render, staticRenderFns } from "./Learn.vue?vue&type=template&id=0a39c9c5&"
import script from "./Learn.vue?vue&type=script&lang=js&"
export * from "./Learn.vue?vue&type=script&lang=js&"
import style0 from "./Learn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports